import styled from '@emotion/styled';

import { mediaQuery } from 'src/shared/ds';
import { pxToRem } from 'src/shared/helpers/pxToRem';

interface QuestionWrapperProps {
    scrollContent?: boolean;
    additionalVerticalPadding?: boolean;
}

export const QuestionWrapper = styled.div<QuestionWrapperProps>(
    ({ scrollContent, additionalVerticalPadding }) => ({
        width: 540,
        display: 'flex',
        flex: 1,
        padding: `${pxToRem(additionalVerticalPadding ? 30 : 0)} 0`,
        flexDirection: 'column',
        justifyContent: 'center',
        marginTop: scrollContent ? pxToRem(20) : '-10%',
        [mediaQuery.maxHeight('sm')]: {
            marginTop: 0,
        },
    }),
);
